import wishlist from './wishlist';
import courses from './courses';

export default {
    wishlist, courses
}